import { Spinner as CircularProgress } from '../styleguide/icons/Spinner'

export default CircularProgress
